
(function () {
  if (window.MPDynamicCartUpsells) return;

  var SOURCE = 'shopify_theme_draft_dynamic_cart_upsells';
  var state = { rendering: false, acting: false, lastSignature: '' };



  function ensureStyles() {
    if (document.getElementById('mp-dynamic-upsell-styles')) return;
    var style = document.createElement('style');
    style.id = 'mp-dynamic-upsell-styles';
    style.textContent = `
      #mp-dynamic-cart-upsells {
        display: block;
        margin: 1.2rem 0 1.5rem;
        padding: 0 1.5rem;
      }
      #mp-dynamic-cart-upsells[hidden] { display: none !important; }
      .mp-dynamic-upsell-panel {
        border: 0.1rem solid #ff8000;
        border-radius: 1.4rem;
        background: #fff7ed;
        padding: 1.4rem;
      }
      .mp-dynamic-upsell-panel__eyebrow {
        margin: 0 0 0.35rem;
        color: #ff8000;
        font-size: 1.05rem;
        font-weight: 700;
        letter-spacing: 0.03em;
        text-transform: uppercase;
      }
      .mp-dynamic-upsell-panel__title {
        margin: 0;
        font-size: 1.65rem;
        line-height: 1.18;
        font-weight: 700;
      }
      .mp-dynamic-upsell-panel__message {
        margin: 0.55rem 0 0;
        font-size: 1.25rem;
        line-height: 1.38;
      }
      .mp-dynamic-upsell-panel__cards {
        display: grid;
        grid-template-columns: 1fr;
        gap: 1rem;
        margin-top: 1.2rem;
      }
      .mp-dynamic-upsell-card {
        display: grid;
        grid-template-columns: 8.2rem minmax(0, 1fr);
        gap: 1.1rem;
        align-items: start;
        border: 0.1rem solid rgba(255, 128, 0, 0.28);
        border-radius: 1.2rem;
        background: #fff;
        padding: 1rem;
      }
      .mp-dynamic-upsell-card__image-wrap {
        width: 8.2rem;
        height: 8.2rem;
        border-radius: 1rem;
        background: #fff6ea;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .mp-dynamic-upsell-card__image {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .mp-dynamic-upsell-card__badge {
        display: inline-flex;
        margin-bottom: 0.35rem;
        padding: 0.25rem 0.7rem;
        border-radius: 999px;
        background: rgba(255, 128, 0, 0.12);
        color: #b85c00;
        font-size: 1.02rem;
        font-weight: 700;
      }
      .mp-dynamic-upsell-card__title {
        margin: 0;
        font-size: 1.48rem;
        line-height: 1.22;
        font-weight: 700;
      }
      .mp-dynamic-upsell-card__text {
        margin: 0.35rem 0 0;
        font-size: 1.22rem;
        line-height: 1.35;
      }
      .mp-dynamic-upsell-card__variant-label {
        display: block;
        margin-top: 0.75rem;
        font-size: 1.08rem;
        font-weight: 600;
      }
      .mp-dynamic-upsell-card__variant {
        width: 100%;
        margin-top: 0.25rem;
        min-height: 3.6rem;
        border: 0.1rem solid rgba(0, 0, 0, 0.2);
        border-radius: 0.8rem;
        padding: 0.55rem 0.8rem;
        background: #fff;
        color: inherit;
        font: inherit;
      }
      .mp-dynamic-upsell-card__bottom {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 0.8rem;
        margin-top: 0.9rem;
      }
      .mp-dynamic-upsell-card__price {
        color: #ff8000;
        font-size: 1.42rem;
        font-weight: 800;
        white-space: nowrap;
      }
      .mp-dynamic-upsell-card__button {
        min-height: 3.8rem;
        border: none;
        border-radius: 0.9rem;
        padding: 0.75rem 1.1rem;
        background: #ff8000;
        color: #fff;
        font: inherit;
        font-size: 1.12rem;
        font-weight: 700;
        letter-spacing: 0.01em;
        cursor: pointer;
        transition: transform 160ms ease, background 160ms ease;
      }
      .mp-dynamic-upsell-card__button:active {
        transform: translateY(1px) scale(0.99);
      }
      .mp-dynamic-upsell-card__button[disabled] {
        opacity: 0.6;
        cursor: wait;
      }
      @media screen and (max-width: 420px) {
        #mp-dynamic-cart-upsells { padding: 0 1rem; }
        .mp-dynamic-upsell-card { grid-template-columns: 6.8rem minmax(0, 1fr); }
        .mp-dynamic-upsell-card__image-wrap { width: 6.8rem; height: 6.8rem; }
        .mp-dynamic-upsell-card__bottom { align-items: stretch; flex-direction: column; }
        .mp-dynamic-upsell-card__button { width: 100%; }
      }
    `;
    document.head.appendChild(style);
  }

  function readConfig() {
    var el = document.getElementById('mp-dynamic-upsell-config');
    if (!el || !el.textContent) return null;
    try { return JSON.parse(el.textContent); }
    catch (error) {
      console.warn('[MuffaPro Dynamic Upsells] Invalid config', error);
      return null;
    }
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format((Number(cents) || 0) / 100);
    } catch (_) {
      return '€' + (((Number(cents) || 0) / 100).toFixed(2)).replace('.', ',');
    }
  }

  function normalizeVariantId(value) {
    if (value === null || value === undefined) return '';
    return String(value).replace('gid://shopify/ProductVariant/', '');
  }

  function itemHandle(item) {
    if (!item) return '';
    if (item.handle) return item.handle;
    if (item.product_handle) return item.product_handle;
    if (item.url && item.url.indexOf('/products/') !== -1) {
      return item.url.split('/products/')[1].split('?')[0].split('#')[0].split('/')[0];
    }
    return '';
  }

  function isAutoGiftItem(item) {
    return !!(item && item.properties && String(item.properties._mp_auto_gift) === 'true');
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('cart.js ' + response.status);
      return response.json();
    });
  }

  function availableVariant(product) {
    if (!product || !product.variants) return null;
    return product.variants.find(function (variant) { return variant.available; }) || product.variants[0] || null;
  }

  function cartHandles(cart) {
    var handles = [];
    (cart.items || []).forEach(function (item) {
      if (isAutoGiftItem(item)) return;
      var handle = itemHandle(item);
      if (handle && handles.indexOf(handle) === -1) handles.push(handle);
    });
    return handles;
  }

  var COMPLETE_KIT_HANDLES = ['kit-consolidante-anticondensa', 'kit-termico-anticondensa'];
  var LOWER_TIER_HANDLES = [
    'kit-essenziale-antimuffa',
    'spray-rimuovi-muffa',
    'igienizzante-antimuffa',
    'pittura-anticondensa',
    'microgel-termo-fondo',
    'nanoconsolidante-biocida'
  ];
  var CYCLE_SINGLE_HANDLES = ['pittura-anticondensa', 'microgel-termo-fondo', 'nanoconsolidante-biocida'];

  function hasHandle(handles, handle) {
    return handles.indexOf(handle) !== -1;
  }

  function hasAnyHandle(handles, wanted) {
    return wanted.some(function (handle) { return hasHandle(handles, handle); });
  }

  function ruleById(rules, id) {
    return (rules || []).find(function (rule) { return rule && rule.id === id; }) || null;
  }

  function firstMatchingRule(rules, handles) {
    for (var i = 0; i < rules.length; i += 1) {
      var rule = rules[i];
      if (!rule || !rule.triggers) continue;
      if (rule.triggers.some(function (handle) { return hasHandle(handles, handle); })) return rule;
    }
    return null;
  }

  function chooseRule(config, cart) {
    var handles = cartHandles(cart);
    var rules = (config && config.rules) || [];

    // Read the cart as a hierarchy, not as isolated product triggers.
    // A full treatment kit supersedes Kit Essenziale and single components, so lower-tier products must not keep showing "upgrade to full kit" cards.
    if (hasHandle(handles, 'kit-consolidante-anticondensa')) return ruleById(rules, 'kit-consolidante-addon');
    if (hasHandle(handles, 'kit-termico-anticondensa')) return ruleById(rules, 'kit-termico-addon');

    // If the customer is buying a single cycle component, use product-specific copy.
    if (hasHandle(handles, 'nanoconsolidante-biocida')) return ruleById(rules, 'nanoconsolidante-upgrade');
    if (hasHandle(handles, 'microgel-termo-fondo')) return ruleById(rules, 'microgel-termo-fondo-upgrade');
    if (hasHandle(handles, 'pittura-anticondensa')) return ruleById(rules, 'pittura-anticondensa-upgrade');

    if (hasHandle(handles, 'kit-essenziale-antimuffa')) return ruleById(rules, 'kit-essenziale-upgrade');

    // Spray + Igienizzante together should use the broader "part of the treatment" copy, not only the Spray removal copy.
    if (hasHandle(handles, 'igienizzante-antimuffa')) return ruleById(rules, 'igienizzante-upgrade');
    if (hasHandle(handles, 'spray-rimuovi-muffa')) return ruleById(rules, 'spray-upgrade');

    if (hasHandle(handles, 'kit-prevenzione')) return ruleById(rules, 'kit-prevenzione-addon-upgrade');

    return firstMatchingRule(rules, handles);
  }

  function visibleSuggestions(config, cart, rule) {
    if (!rule) return [];
    var handles = cartHandles(cart);
    var products = config.products || {};
    var hasTermico = hasHandle(handles, 'kit-termico-anticondensa');
    var hasConsolidante = hasHandle(handles, 'kit-consolidante-anticondensa');
    var hasCompleteKit = hasTermico || hasConsolidante;

    return (rule.suggestions || []).filter(function (suggestion) {
      if (!suggestion || !suggestion.handle || !products[suggestion.handle]) return false;
      if (handles.indexOf(suggestion.handle) !== -1) return false;

      // Once a full kit is already in cart, never recommend another full kit or a lower-tier kit as an upgrade.
      if (hasCompleteKit && (COMPLETE_KIT_HANDLES.indexOf(suggestion.handle) !== -1 || suggestion.handle === 'kit-essenziale-antimuffa')) return false;
      if (hasTermico && suggestion.handle === 'kit-consolidante-anticondensa') return false;
      if (hasConsolidante && suggestion.handle === 'kit-termico-anticondensa') return false;

      return !!availableVariant(products[suggestion.handle]);
    }).slice(0, 2);
  }

  function ensureContainer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return null;
    var container = drawer.querySelector('#mp-dynamic-cart-upsells');
    if (container) return container;

    container = document.createElement('section');
    container.id = 'mp-dynamic-cart-upsells';
    container.className = 'mp-dynamic-cart-upsells';

    var gift = drawer.querySelector('cart-drawer-gift, .cart-drawer-gift');
    if (gift && gift.parentNode) {
      gift.parentNode.insertBefore(container, gift.nextSibling);
      return container;
    }

    var items = drawer.querySelector('cart-drawer-items');
    if (items && items.parentNode) {
      items.parentNode.insertBefore(container, items.nextSibling);
      return container;
    }

    var footer = drawer.querySelector('.cart-drawer__footer, .cart__ctas');
    if (footer && footer.parentNode) {
      footer.parentNode.insertBefore(container, footer);
      return container;
    }

    var body = drawer.querySelector('.cart-drawer__body, .drawer__inner');
    if (body) body.appendChild(container);
    return container;
  }

  function optionHtml(variant) {
    return '<option value="' + normalizeVariantId(variant.id) + '" data-price="' + Number(variant.price || 0) + '">' +
      escapeHtml(variant.title || 'Default') + ' · ' + money(variant.price) + '</option>';
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function cardHtml(config, rule, suggestion, index) {
    var product = config.products[suggestion.handle];
    var variants = (product.variants || []).filter(function (variant) { return variant.available; });
    if (!variants.length) variants = product.variants || [];
    var firstVariant = variants[0] || availableVariant(product);
    var image = product.image || '';
    var action = suggestion.action || rule.mode || 'add';
    var cta = suggestion.cta || (action === 'replace' ? 'Sostituisci' : 'Aggiungi al carrello');
    var badge = action === 'replace' ? 'Upgrade consigliato' : 'Completa il trattamento';

    return '' +
      '<article class="mp-dynamic-upsell-card" data-action="' + escapeHtml(action) + '" data-handle="' + escapeHtml(suggestion.handle) + '" data-rule-id="' + escapeHtml(rule.id || '') + '" data-index="' + index + '">' +
        '<div class="mp-dynamic-upsell-card__image-wrap">' +
          (image ? '<img class="mp-dynamic-upsell-card__image" src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : '') +
        '</div>' +
        '<div class="mp-dynamic-upsell-card__content">' +
          '<div class="mp-dynamic-upsell-card__badge">' + escapeHtml(suggestion.badge || badge) + '</div>' +
          '<h4 class="mp-dynamic-upsell-card__title">' + escapeHtml(product.title) + '</h4>' +
          (suggestion.text ? '<p class="mp-dynamic-upsell-card__text">' + escapeHtml(suggestion.text) + '</p>' : '') +
          (variants.length > 1 ? '<label class="mp-dynamic-upsell-card__variant-label">Formato<select class="mp-dynamic-upsell-card__variant">' + variants.map(optionHtml).join('') + '</select></label>' : '') +
          '<div class="mp-dynamic-upsell-card__bottom">' +
            '<span class="mp-dynamic-upsell-card__price">' + money(firstVariant && firstVariant.price) + '</span>' +
            '<button type="button" class="mp-dynamic-upsell-card__button" data-action="' + escapeHtml(action) + '">' + escapeHtml(cta) + '</button>' +
          '</div>' +
        '</div>' +
      '</article>';
  }

  function renderCart(cart) {
    var config = readConfig();
    var container = ensureContainer();
    if (!config || !container) return;

    var rule = chooseRule(config, cart);
    var suggestions = visibleSuggestions(config, cart, rule);
    var signature = JSON.stringify({
      items: (cart.items || []).map(function (item) { return [itemHandle(item), item.quantity, isAutoGiftItem(item)]; }),
      rule: rule && rule.id,
      suggestions: suggestions.map(function (suggestion) { return suggestion.handle + ':' + suggestion.action; })
    });

    if (signature === state.lastSignature && container.dataset.rendered === 'true') return;
    state.lastSignature = signature;

    if (!rule || !suggestions.length) {
      container.innerHTML = '';
      container.hidden = true;
      container.dataset.rendered = 'false';
      return;
    }

    container.hidden = false;
    container.dataset.rendered = 'true';
    container.innerHTML = '' +
      '<div class="mp-dynamic-upsell-panel mp-dynamic-upsell-panel--' + escapeHtml(rule.mode || 'add') + '">' +
        '<div class="mp-dynamic-upsell-panel__header">' +
          '<p class="mp-dynamic-upsell-panel__eyebrow">' + escapeHtml(rule.eyebrow || 'Consiglio MuffaPro') + '</p>' +
          '<h3 class="mp-dynamic-upsell-panel__title">' + escapeHtml(rule.title || '') + '</h3>' +
          (rule.message ? '<p class="mp-dynamic-upsell-panel__message">' + escapeHtml(rule.message) + '</p>' : '') +
        '</div>' +
        '<div class="mp-dynamic-upsell-panel__cards">' + suggestions.map(function (suggestion, index) { return cardHtml(config, rule, suggestion, index); }).join('') + '</div>' +
      '</div>';
  }

  function render() {
    ensureStyles();
    if (state.rendering) return;
    state.rendering = true;
    getCart().then(renderCart).catch(function (error) {
      console.warn('[MuffaPro Dynamic Upsells] Render failed', error);
    }).finally(function () {
      state.rendering = false;
    });
  }

  function selectedVariantId(card) {
    var select = card.querySelector('.mp-dynamic-upsell-card__variant');
    if (select && select.value) return select.value;
    var config = readConfig();
    var product = config && config.products && config.products[card.dataset.handle];
    var variant = availableVariant(product);
    return variant ? normalizeVariantId(variant.id) : '';
  }

  function selectedPrice(card) {
    var select = card.querySelector('.mp-dynamic-upsell-card__variant');
    if (select && select.selectedOptions && select.selectedOptions[0]) return Number(select.selectedOptions[0].dataset.price || 0);
    var config = readConfig();
    var product = config && config.products && config.products[card.dataset.handle];
    var variant = availableVariant(product);
    return Number((variant && variant.price) || 0);
  }

  function addVariant(variantId, quantity, properties) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: normalizeVariantId(variantId), quantity: quantity || 1, properties: properties || {} }] })
    }).then(function (response) {
      if (!response.ok) throw new Error('cart/add.js ' + response.status);
      return response.json();
    });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (response) {
      if (!response.ok) throw new Error('cart/change.js ' + response.status);
      return response.json();
    });
  }

  function refreshCartSections(keepOpen) {
    var sections = ['cart-drawer', 'cart-icon-bubble'];
    var path = window.location.pathname || '/';
    return fetch(path + '?sections=' + sections.join(','), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('sections ' + response.status);
        return response.json();
      })
      .then(function (htmlBySection) {
        if (htmlBySection['cart-drawer']) {
          var doc = new DOMParser().parseFromString(htmlBySection['cart-drawer'], 'text/html');
          var incoming = doc.querySelector('cart-drawer');
          var current = document.querySelector('cart-drawer');
          if (incoming && current) {
            current.replaceWith(incoming);
            if (keepOpen) {
              var newDrawer = document.querySelector('cart-drawer');
              if (newDrawer) {
                if (typeof newDrawer.open === 'function') newDrawer.open();
                newDrawer.classList.add('active');
                document.body.classList.add('overflow-hidden');
              }
            }
          }
        }
        if (htmlBySection['cart-icon-bubble']) {
          var bubbleDoc = new DOMParser().parseFromString(htmlBySection['cart-icon-bubble'], 'text/html');
          var incomingBubble = bubbleDoc.body.firstElementChild;
          var currentBubble = document.getElementById('cart-icon-bubble') || document.querySelector('[id*="cart-icon-bubble"]');
          if (incomingBubble && currentBubble) currentBubble.replaceWith(incomingBubble);
        }
      }).then(function () {
        render();
      }).catch(function () {
        window.location.reload();
      });
  }

  function capture(eventName, payload) {
    try {
      var props = Object.assign({ source: SOURCE }, payload || {});
      if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(eventName, props);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, props));
    } catch (_) {}
  }

  function matchingRemoveHandles(rule, suggestion) {
    var handles = [];
    (suggestion.removeHandles || rule.removeHandles || rule.triggers || []).forEach(function (handle) {
      if (handles.indexOf(handle) === -1) handles.push(handle);
    });

    // Replacing with a superior kit should clean up lower-tier duplicates that the new kit supersedes.
    if (suggestion && (COMPLETE_KIT_HANDLES.indexOf(suggestion.handle) !== -1 || suggestion.handle === 'kit-essenziale-antimuffa')) {
      LOWER_TIER_HANDLES.forEach(function (handle) {
        if (handles.indexOf(handle) === -1) handles.push(handle);
      });
    }
    return handles;
  }

  function performAction(card) {
    if (!card || state.acting) return;
    var config = readConfig();
    var rule = config && (config.rules || []).find(function (item) { return item.id === card.dataset.ruleId; });
    var suggestion = rule && (rule.suggestions || [])[Number(card.dataset.index || 0)];
    if (!config || !rule || !suggestion) return;

    var action = suggestion.action || rule.mode || card.dataset.action || 'add';
    var variantId = selectedVariantId(card);
    if (!variantId) return;

    state.acting = true;
    var button = card.querySelector('.mp-dynamic-upsell-card__button');
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }

    var work = Promise.resolve();
    if (action === 'replace') {
      work = getCart().then(function (cart) {
        var removeHandles = matchingRemoveHandles(rule, suggestion);
        var lines = (cart.items || []).filter(function (item) {
          return !isAutoGiftItem(item) && removeHandles.indexOf(itemHandle(item)) !== -1;
        });
        return lines.reduce(function (promise, item) {
          return promise.then(function () { return changeLine(item.key, 0); });
        }, Promise.resolve());
      });
    }

    work.then(function () {
      return addVariant(variantId, 1, {
        _mp_dynamic_upsell: 'true',
        _mp_dynamic_upsell_action: action,
        _mp_dynamic_upsell_rule: rule.id || ''
      });
    }).then(function () {
      capture(action === 'replace' ? 'Cart Dynamic Upgrade Replaced' : 'Cart Dynamic Upsell Added', {
        rule_id: rule.id,
        target_handle: suggestion.handle,
        target_variant_id: variantId,
        action: action
      });
      if (window.MPNativeCartGiftSync && typeof window.MPNativeCartGiftSync.sync === 'function') {
        return window.MPNativeCartGiftSync.sync('dynamic_upsell_action');
      }
    }).then(function () {
      return refreshCartSections(true);
    }).catch(function (error) {
      console.warn('[MuffaPro Dynamic Upsells] Action failed', error);
      if (button) button.disabled = false;
    }).finally(function () {
      state.acting = false;
      if (button) button.removeAttribute('aria-busy');
    });
  }

  document.addEventListener('change', function (event) {
    var select = event.target && event.target.closest && event.target.closest('.mp-dynamic-upsell-card__variant');
    if (!select) return;
    var card = select.closest('.mp-dynamic-upsell-card');
    var price = card && card.querySelector('.mp-dynamic-upsell-card__price');
    if (price) price.textContent = money(selectedPrice(card));
  });

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest && event.target.closest('.mp-dynamic-upsell-card__button');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    performAction(button.closest('.mp-dynamic-upsell-card'));
  }, true);

  var renderTimer;
  function scheduleRender(delay) {
    window.clearTimeout(renderTimer);
    renderTimer = window.setTimeout(render, delay || 350);
  }

  document.addEventListener('DOMContentLoaded', function () { scheduleRender(500); });
  window.addEventListener('pageshow', function () { scheduleRender(500); });

  var observer = new MutationObserver(function () { scheduleRender(500); });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.MPDynamicCartUpsells = { render: render, config: readConfig };
})();
